import axios from 'axios';

// Create an Axios instance with default configurations
const apiClient = axios.create({
  // In production build, this will use the proper URL from environment
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3001/api/',
  withCredentials: true, // Send cookies with requests
});


// Add interceptor to handle expected auth errors silently
apiClient.interceptors.response.use(
  response => response,
  error => {
    // Don't log expected auth errors (401s) to console
    if (error.response && error.response.status === 401 && 
        (error.config.url === '/auth/load' || error.config.url === '/auth/user')) {
      // Return a rejected promise but with a flag to identify it as an expected auth error
      return Promise.reject({
        ...error,
        isAuthError: true // Add flag so action creators can identify expected auth errors
      });
    }
    
    // Log all other errors normally
    return Promise.reject(error);
  }
);

// Auth Endpoints
export const initialLoad = () => apiClient.get('/auth/load');
export const signUp = (data) => apiClient.post('/auth/signup', data);
export const logIn = (data) => apiClient.post('/auth/login', data);
export const logOut = () => apiClient.get('/auth/logout');
export const resetPW = (email) => apiClient.post('/auth/resetpw', email);
export const updatePW = (data) => apiClient.post('/auth/updatepw', data);

// Jobs Endpoints
export const createJob = (data) => apiClient.post('/jobs/saved', data);
export const findAllJobsForUser = () => apiClient.get('/jobs/saved');
export const getJobById = (id) => apiClient.get(`/jobs/saved/${id}`);
export const deleteJobById = (id) => apiClient.delete(`/jobs/saved/${id}`);
export const updateJobById = (id, data) => apiClient.put(`/jobs/saved/${id}`, data);

// Chart Endpoints
export const aggregateJobDataForCharts = () => apiClient.get('/jobs/chart/all');
export const getJobDataUser = () => apiClient.get('/jobs/chart/user');
export const getUserPercentile = (saved, applied, phone, onSite, offer) =>
  apiClient.get(`/jobs/chart/user/percentile/?saved=${saved}&applied=${applied}&phone=${phone}&onSite=${onSite}&offer=${offer}`);

// Search Endpoints
export const getSearchResults = (keywords, location) =>
  apiClient.get(`/jobs/search/?keywords=${keywords}&location=${location}`);
